import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/outer-products";

export default createStore({ Model });
